export default __webpack_public_path__ + "static/media/CNo.38-1.ff3f2ae6.jpg";